export default "__VITE_ASSET__CgT5b68z__"